
angular
    .module('meevo.plugins.register')
    .filter('saleLinesByClient', [
        () => (saleLines, clientObj) => {
            var filtered = [];
            if (saleLines) {
                saleLines.forEach(saleLine => {
                    if (saleLine.saleType === Meevo.Model.SalesTypeEnum.AssociatedClient) {
                        return;
                    }

                    if (saleLine.saleType === Meevo.Model.SalesTypeEnum.PaymentSurcharge && !saleLine.isRefund) {
                        return;
                    }

                    if ((clientObj.client && !!clientObj.client.id && saleLine.clientId == clientObj.client.id) ||
                        (clientObj.clientType && clientObj.appointmentId == saleLine.appointmentId && clientObj.clientType != Meevo.Model.ClientTypeEnum.Client && saleLine.clientType == clientObj.clientType)) {
                        filtered.push(saleLine);
                    }
                });
            }
            return filtered;
        }
    ])
    .filter('saleItemsByClientAndSaleType', [
        () => (saleItems, params) => {
            var filtered = [];
            var [clientId, allowedSaleTypes] = params;
            if (saleItems) {
                saleItems.forEach((saleItem: { item: Meevo.Model.SaleLine }) => {
                    if (saleItem.item.clientId === clientId && (allowedSaleTypes.length === 0 || _.contains(allowedSaleTypes, saleItem.item.saleType))) {
                        //In combination with selectPredefinedDiscount of discounts.section.ts, keep in sync with DiscountLogic.IsSaleTypeDiscountTypeMatch
                        if (saleItem.item.saleType === Meevo.Model.SalesTypeEnum.MembershipPayment) {
                            let billFeeType = (<Meevo.Model.MembershipPaymentSaleLineItem>saleItem.item.item).clientMembershipBillFeeType;
                            if (billFeeType !== Meevo.Model.ClientMembershipBillFeeTypeEnum.FreezeFee &&
                                billFeeType !== Meevo.Model.ClientMembershipBillFeeTypeEnum.PaidInFullFreezeFee) {
                                return;
                            }
                        }
                        filtered.push(saleItem);
                    }
                });
            }
            return filtered;
        }
    ]);
